import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";

export default function BindingsPeriodeArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Der er 6 måneders binding på dit Hiper Bredbånd, som gælder fra leveringsdatoen.
                            Hvis du vælger at opsige dit abonnement, får du en bekræftelse i en mail, hvor du se den præcise slutdato for abonnementet, og hvordan du skal returnere det fremsendte udstyr.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "mit-abonnement",
                        "article": "skal-du-flytte",
                        "name": "Skal du flytte?"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "overdrag-dit-internet-til-anden-person",
                        "name": "Overdrag dit internet til en anden"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "returner-udstyr",
                        "name": "Hvordan returnerer jeg mit udstyr?"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "fortrydelsesret",
                        "name": "Hvor lang fortrydelsesret har jeg?"
                    }
                ]}
            />
        </>
    )
}
